export const memberships = {
    "one_month_credit": {"full_name": "ELSA PRO 1 Month", "time": "Month"},
    "three_months_credit": {"full_name": "ELSA PRO 3 Months", "time": "3 Months"},
    "six_months_credit": {"full_name": "ELSA PRO 6 Months", "time": "6 Months"},
    "one_year_credit": {"full_name": "ELSA PRO 1 Year", "time": "Year"},
}
